import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { heroImage, statsData } from '../data/mock';
import { Button } from './ui/button';
import { ArrowRight, Phone } from 'lucide-react';

const HeroSection = ({ scrollToSection }) => {
  const { t, language } = useLanguage();

  return (
    <section id="hero" className="relative min-h-screen pt-20">
      {/* Hero Image Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="/karyemek.jpg"
          alt="Kar Yemek"
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.src = heroImage;
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-gray-900/60 to-transparent"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[calc(100vh-80px)] flex items-center">
        <div className="max-w-2xl">
          <p className="text-amber-400 font-medium text-lg mb-4 animate-fade-in">
            {t('hero.since')}
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {t('hero.title')}
          </h1>
          <p className="text-xl sm:text-2xl text-gray-200 mb-8">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              size="lg"
              className="bg-amber-500 hover:bg-amber-600 text-white font-semibold px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all group"
              onClick={() => scrollToSection('hizmetler')}
            >
              {t('hero.btnServices')}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 font-semibold px-8 py-6 text-lg transition-all"
              onClick={() => scrollToSection('iletisim')}
            >
              <Phone className="mr-2 w-5 h-5" />
              {t('hero.btnContact')}
            </Button>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="relative z-10 bg-white py-12 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {statsData.map((stat, index) => (
              <div
                key={index}
                className="text-center group"
              >
                <div className="text-4xl sm:text-5xl font-bold text-amber-500 mb-2 group-hover:scale-110 transition-transform">
                  {stat.value}
                </div>
                <p className="text-gray-600 font-medium">
                  {t(`stats.${stat.key}`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
